export const signatures = {
  manageSignaturesTitle: 'Zarządzaj sygnaturami',
  manageSignaturesPara: 'Edytuj i zarządzaj kolejnością sygnatur w konfguracji',
  unassignedSignatures: 'Nieprzypisane sygnatury',
  assignedSignatures: 'Utworzona sygnatura',
  updatedSignature: 'Zaktualizowano sygnaturę',
  noUnassignedSignatures: 'Brak nieprzypisanych sygnatur',
  noAssignedSignature: 'Brak utworzono sygnatury',
}
